import { apiErrorCodes } from '../../utils/apiHelper'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getErrorMessage = (action) => {
  const errorCode = action.payload.ErrorCodes
  if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
    return action.payload.UserFriendlyErrorCode ?
        getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
      : ''
  }
  switch (errorCode) {
    case apiErrorCodes.PATIENT_NOT_FOUND:
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Patient')
    case apiErrorCodes.FILE_NOT_FOUND:
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'File')
    case apiErrorCodes.PERIOD_NOT_VALID:
      return getUserFriendlyErrorMessage(errorCodes.REPEAT_TIME_AFTER_END)
    case apiErrorCodes.FILE_TAG_NOT_VALID:
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Tags')
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
